import React from "react";
import { Statistic } from "antd";

const StatisticAmount = (props) => {
    return <Statistic title={props.title} prefix={props.type} value={props.value} {...props} />;
};

export default StatisticAmount;
